import React, { useEffect, useState } from "react";

import {
  Form,
  Input,
} from "antd";
import { useForm } from "antd/es/form/Form";

import MyForm from "../../MyForm";

import "./SignupForm.css";
import "./CompanyInfoForm.css";
import useHandleStepChange from "../useHandleStepChange";
import FormButtons from "./ReusableComponents/FormButtons";

import { checkUser } from "../../../../utils/common";
import { validatePassword } from "../../../Common/utils/validationUtils";

import { ReactComponent as CloseIcon } from "../../../../assets/images/onboarding/clearfield_2.svg";

export default function SignupForm({
  initialValues,
  email,
  company_name,
  customer_name,
  phoneValidator,
  existingUser,
  setExistingUser,
  handleSubmit,
  onBackButton,
  onFinishFailed,
  submitting,
  stepChangeInProgress,
  handleFormStepChange,
}) {
  const FORM_NAME = "signup_form";
  const [form] = useForm();
  const [checkUserLoading, setCheckUserLoading] = useState(false);

  useEffect(() => {
    async function checkUserExists(mail) {
      setCheckUserLoading(true);
      const { success, firebase_exist_status, phone_number } = await checkUser(mail);
      if (success) {
        setExistingUser(firebase_exist_status);
        if (phone_number) {
          form.setFieldValue("phone_number", phone_number);
        }
      } else {
        setExistingUser(false);
      }
      setCheckUserLoading(false);
    }
    checkUserExists(email);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  /** Hook that handles form saving + step change when step is clicked */
  useHandleStepChange(FORM_NAME, form, stepChangeInProgress, handleFormStepChange);

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
    layout: "vertical",
  };

  const passwordRequirementValidator = async (_, value) => {
    if (!value || validatePassword(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Password does not meet the requirements"));
  };

  return (
    <MyForm
      {...layout}// eslint-disable-line react/jsx-props-no-spreading
      form={form}
      initialValues={{
        ...initialValues, email, company_name, existingUser, customer_name,
      }}
      requiredMark={false}
      validateTrigger={["onChange", "onBlur"]}
      name={FORM_NAME}
      onFinish={(values) => handleSubmit(FORM_NAME, values)}
      onFinishFailed={onFinishFailed}
      disabled={submitting}
      className="OnboardingForm"
    >
      <div className="SignUp__MainForm">
        <div className="OnboardingFormSubTitle OnboardingFormSubTitle--first SignupForm__SectionTitle">
          <span />
          <p className="OnboardingFormSubTitleText">Final Step!</p>
        </div>
        <Form.Item
          name="company_name"
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Company Name</span>}
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="email"
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Email</span>}
          rules={[
            {
              required: true, message: "",
            },
          ]}
        >
          <Input type="email" disabled />
        </Form.Item>

        <Form.Item
          name="phone_number"
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Phone number (optional)</span>}
          rules={[
            {
              validator: phoneValidator,
            },
            { max: 100, message: "Phone number cannot be longer than 100 characters" },
          ]}
        >
          <Input
            type="tel"
            allowClear={{ clearIcon: <CloseIcon className="Clear__Button" /> }}
            autoComplete="off"
            disabled={existingUser}
          />
        </Form.Item>

        <Form.Item
          name="password"
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Password</span>}
          extra={(
            <span className="SignupForm__PasswordDesc">
              Must contain at least one number and one uppercase and lower case letter and at least 6 or more characters
            </span>
          )}
          rules={[
            {
              required: !existingUser,
              message: "",
            },
            {
              validator: passwordRequirementValidator,
            },
          ]}
          className="SignupForm_PasswordItem"
        >
          <Input.Password
            placeholder={existingUser ? "" : "Enter password"}
            autoComplete="new-password"
            disabled={existingUser}
            visibilityToggle={false}
            allowClear={{ clearIcon: <CloseIcon className="Clear__Button" /> }}
          />
        </Form.Item>

        <Form.Item
          name="confirm"
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Confirm Password</span>}
          dependencies={["password"]}
          rules={[
            {
              required: !existingUser,
              message: "",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Does not match inputted password"));
              },
            }),
          ]}
          className="SignupForm_PasswordConfirm"
        >
          <Input.Password
            autoComplete="new-password"
            disabled={existingUser}
            visibilityToggle={false}
            allowClear={{ clearIcon: <CloseIcon className="Clear__Button" /> }}
          />
        </Form.Item>
      </div>
      <FormButtons
        handleBack={() => onBackButton(FORM_NAME, form.getFieldValue())}
        nextButtonText="Set up Genista"
        loading={submitting}
        nextDisabled={checkUserLoading}
      />
    </MyForm>

  );
}
